// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__17NZ7","header":"ClearentDisclaimer_header__8_fuE","inner":"ClearentDisclaimer_inner__-91nI"};